<template>
    <div class="container">
        <div class="row">
            <!-- <div class="col-sm-4 mb-2"> -->
            <!--     <page-nav icn="fas fa-upload text-primary" lab="郵便番号CSV(upload)" @do_click="postalUpload"></page-nav> -->
            <!-- </div> -->
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-paper-plane text-primary" lab="システム通知送信" @do_click="sysMail"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-history text-primary" lab="ユーザー操作追跡" @do_click="userOptHis"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-file-medical-alt text-primary" lab="シェア情報閲覧履歴" @do_click="shareAccessHis"></page-nav>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import PageNav from 'pages/commons/nav/PageNav'

    export default {
        components: {
            PageNav
        },
        methods: {
            postalUpload () {
                this.$router.push({name:'PostalUpload'})
            },
            sysMail () {
                this.$router.push({name:'SysMail'})
            },
            userOptHis () {
                this.$router.push({name:'UserOptHis'})
            },
            shareAccessHis () {
                this.$router.push({name:'ShareAccessHis'})
            }
        }
    }
</script>

<style lang="stylus" scoped>

</style>
